import axios from 'axios';
import { getLoginUser, logout, updateLoginUser } from './login';
import { alert, authAlert } from '@/utility/messages';
import { axiosConnections } from '@/utility/axios-lib-utilities';
import router from '@/router';
import { toLoginName } from '@/router/index';
import { HttpError } from '@/error/error-ex';

const authErr = 401; //< 認証エラーコード コードを変更したいのならC#側の変更が必要
const controllableErr = 406; //< 例外ダイアログの表示をしない例外 コードを変更したいのならC#側の変更が必要

axios.interceptors.request.use(config => {
  axiosConnections.value++;
  const user = getLoginUser();
  if (user && config.headers) {
    config.headers.Authorization = 'Bearer ' + user.token;
  }
  return config;
});

axios.interceptors.response.use(
  value => {
    axiosConnections.value--;
    updateLoginUser();
    return value;
  },
  async error => {
    axiosConnections.value--;
    updateLoginUser();
    const data = error?.response?.data;
    if (data) {
      const message = typeof data === 'string' ? data : data instanceof Blob ? await data.text() : JSON.stringify(data);
      if (error?.response?.status === authErr) {
        authAlert('認証エラーが発生しました。ログインし直すと利用できます。\n' + message);
      } else if (error?.response?.status === controllableErr) {
        alert(`エラーが発生しました。\n${message}`, 'width: auto; max-width:900px;');
        return Promise.reject(new HttpError(message));
      } else {
        alert(`致命的なエラーが発生したため、ログアウトします。\n${message}`, 'width: auto; max-width:900px;').then(() => {
          logout();
          router.push({ name: toLoginName(router.currentRoute.value.fullPath) });
        });
      }
    } else if (error) {
      const messages = [] as string[];
      if (typeof error.message === 'string' && error.message) {
        messages.push(error.message);
      }
      if (typeof error.request?.responseURL === 'string' && error.request.responseURL) {
        messages.push('url: ' + error.request.responseURL);
      }
      alert(messages.join('\n'));
    }
  }
);
